export default __webpack_public_path__ + "static/media/arrow-left-ffffff.b98202b9.svg";